
import * as React from "react";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Menu, X, ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import { navigationItems } from "./navigation-items";
import { NavigationItem } from "./types";

const MenuItem = ({
  item
}: {
  item: NavigationItem;
}) => {
  const Icon = item.icon;
  return <a href={item.href} className="flex items-center p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-all text-white hover:text-racing-accent group">
      <div className="h-8 w-8 rounded-full bg-[#f94933]/10 flex items-center justify-center group-hover:bg-[#f94933]/20 transition-colors">
        <Icon className="h-4 w-4 text-[#f94933]" />
      </div>
      <span className="ml-3 font-medium">{item.title}</span>
      <ExternalLink className="w-4 h-4 ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-racing-accent" />
    </a>;
};

const MenuButton = ({
  isOpen,
  onClick
}: {
  isOpen: boolean;
  onClick: () => void;
}) => <button onClick={onClick} aria-label={isOpen ? "Close menu" : "Open menu"} className="fixed top-4 right-4 z-[100] p-2 bg-racing-dark/20 backdrop-blur-md rounded-md transition-colors hover:bg-racing-dark/80">
    <div className="relative w-6 h-6">
      <Menu className={cn("absolute inset-0 w-6 h-6 text-white transition-all duration-300", isOpen ? "opacity-0 rotate-90 scale-0" : "opacity-100 rotate-0 scale-100")} />
      <X className={cn("absolute inset-0 w-6 h-6 text-white transition-all duration-300", isOpen ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-0")} />
    </div>
  </button>;

export const MobileNav = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return <div className="lg:hidden">
      <MenuButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
      
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetContent side="right" className="w-full sm:w-80 p-0 border-gray-800 bg-racing-dark/95 backdrop-blur-md">
          <div className="flex flex-col h-full">
            <div className="p-4 border-b border-gray-800">
              <img src="/lovable-uploads/Front-Runner-Logo.png" alt="Front Runner: Racehorse Manager Logo" className="h-12 w-auto" />
            </div>

            <div className="flex-1 overflow-y-auto py-6 px-4">
              <div className="space-y-6 mb-8">
                <h2 className="px-2 text-racing-orange font-extrabold text-sm">Play</h2>
                <div className="space-y-2">
                  {navigationItems.play.map(item => <MenuItem key={item.title} item={item} />)}
                </div>
              </div>

              <div className="space-y-6">
                <h2 className="px-2 text-racing-orange font-extrabold text-sm">Learn</h2>
                <div className="space-y-2">
                  {navigationItems.learn.map(item => <MenuItem key={item.title} item={item} />)}
                </div>
              </div>
            </div>

            <div className="px-4 py-6 border-t border-gray-800">
              <a
                href="https://play.google.com/apps/testing/com.RTz.TWCGame"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:opacity-80 transition-opacity"
              >
                <img
                  src="/lovable-uploads/070e8c0b-dc54-4dbf-b45e-f848dfc7624e.png"
                  alt="Get Front Runner: Racehorse Manager on Google Play"
                  className="h-12 w-auto"
                />
              </a>
            </div>

            <div className="border-t border-gray-800 p-4">
              <a href="https://thewinnerscircle.io" target="_blank" rel="noopener noreferrer" className="flex items-center justify-start p-3 rounded-lg hover:bg-white/10 transition-all text-white hover:text-racing-accent group">
                <span className="font-medium">The Winners Circle</span>
                <ExternalLink className="w-4 h-4 ml-auto text-racing-accent" />
              </a>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>;
};

